export enum ErrorName {
    INCORRECT_CODE = "Error",
    SIGNIN_EXCEPTION = 'SignInException',
    NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException',
    USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException',
    NO_SESSION = 'NoSession',
}